export default {"src":"https://images-cdn.curipod.com/d-f00f7d60/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};